import { useState } from "react";
import MainLayout from "src/layouts/MainLayout";
import ApplicationTable from "src/components/ApplicationTable";

export default () => {
  const [totalApplicationCount, setTotalApplicationCount] = useState<
    number | undefined
  >(undefined);
  return (
    <MainLayout page="applications" totalCount={totalApplicationCount}>
      <ApplicationTable
        updateTotalApplicationCount={setTotalApplicationCount}
      />
    </MainLayout>
  );
};
